//@ts-nocheck
import React, { useState, useEffect, useContext } from "react";
import { AuthUserContext } from "../../context/auth";
import { Offline, Online } from "react-detect-offline";
import SocketIOClient from "socket.io-client";
// import { Alert  } from '@mui/material'
import bubbleSound from "../../assets/bubble.mp3";
import { Alert, AlertTitle } from "@material-ui/lab";
import classes from "./Layout.module.css";
import { NumberChangeContext } from "../../context/numberchangers";
import MessageSenderNav from "./MessageSenderNav";
import LegalNav from "./LegalNav";
import Logo from "./logo.png";
import tk from "../../images/tk.gif";
import { formatter } from "../../helperFunctions/currencystring";

import { withRouter } from "react-router-dom";
// import LoadScreen from "../../containers/LoadScreen/LoadScreen";
// import MoneySound from "../../assets/MONEYWIN.wav"
import socketIOClient from "socket.io-client";

import REQ from "../../helperFunctions/REQ";
import GLOBAL from "../../containers/GLOBAL/GLOBAL";
import Sidebar from "./Sidebar";
import Logosvg from "../../images/sms-chat.png";
// import { canvasStyles } from '../../constants/styles';
// import ReactCanvasConfetti from 'react-canvas-confetti';
import {
  faArrowCircleRight,
  faBullhorn,
  faCalendarDay,
  faHourglass,
  faMoneyBill,
  faMoneyBillAlt,
  faMoneyBillWaveAlt,
  faNewspaper,
  faRecycle,
  faRedo,
  faSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAlert } from "react-alert";
import RealtimeClock from "../RealTimeClock/RealTimeClock";

function Layout({ children, history }) {
  let [showingMessageDropdown, setShow] = useState(false);
  // let [loadingScreen, setShowLoadingScreen] = useState(true);
  let [status, setStatus] = useState(true);
  let [audioshow, setaudioshow] = useState(false);
  // let [audio] = useState(new Audio(MoneySound));
  // let [playing, setPlaying] = useState(false);

  // let [socket] = useState(SocketIOClient(GLOBAL.domainClickSocket));
  const [socket, setSocket] = useState(null);

  let [fullName, setFullName] = useState("");
  let [userid, setuserid] = useState("");
  let [balance, setbalance] = useState("");
  // let [balancechart, setbalancechart] = useState(0);
  let [viewerid, setviewerid] = useState("");
  let [allowBLAAcess, setallowBLAAcess] = useState(false);
  let [revtoday, setrevtoday] = useState(0);

  let [noconvstats, setnoconvstats] = useState(false);
  let [sidebar, showSideBar] = useState(false);
  let [advertiserId, setAdvertiserId] = useState(null);
  let [showingraw, setshowrawsub] = useState(false);
  let [revloading, setrevloading] = useState(false);
  let [subidalert, setsubidalert] = useState("");
  let [trafficalert, settrafficalert] = useState("");
  let [amountalert, setamountalert] = useState(0);

  const [audiourl, setaudiourl] = useState("");

  const [showAlert, setShowAlert] = useState(false); // New state variable

  const triggerAlert = (subid, traffic, amount) => {
    settrafficalert(traffic);
    setsubidalert(subid);
    setamountalert(amount);
    setShowAlert(true);
    // Optionally, hide the alert after a few seconds

    setTimeout(() => {
      setShowAlert(false);
      settrafficalert("");
      setsubidalert("");
      setamountalert(0);
      // setShowAlert(true);
    }, 5000); // 5 seconds
  };

  const myAlert = useAlert();

  const {
    balancechart,
    setbalancechart,
    // getInstance,
  } = useContext(NumberChangeContext);

  const { user, profitsharer } = useContext(AuthUserContext);
  useEffect(() => {
    const {
      _id,
      fullName,
      status,
      balance,
      allowBLAAcess,
      no_conversion_stats,
      showrawsub,
      advertiser_id,
    } = user;
    setSocket(socketIOClient(GLOBAL.domainClickSocket));
    setshowrawsub(showrawsub);
    setuserid(_id);
    setnoconvstats(no_conversion_stats || false);
    if (profitsharer?._id) {
      console.log("fetching balancechart");
      setviewerid(profitsharer._id);
      fetchpaydata(profitsharer?._id);
    }

    if (advertiser_id) {
      setAdvertiserId(advertiser_id);
    }
    if (status === "number-changer") {
      fetchNumberChangerBalance();
    }

    setFullName(fullName);
    setallowBLAAcess(allowBLAAcess);

    setStatus(status);
    fetchConversions(status);

    setbalance(balance);
  }, []);

  // useEffect(() => {
  //   // triggerAlert("mysub", "mytraffic", 20);
  //   const update = {
  //     sub_id: "subid12345",
  //     traffic: "test traffic",
  //     payout: 20
  //   }
  //        myAlert.show(`conversion  from ${update.traffic} on ${update.sub_id}=>$${update.payout}`, {type:"success",
  //       })
  //        myAlert.show(`conversion  from ${update.traffic} on ${update.sub_id}=>$${update.payout}`, {type:"success",
  //       })
  //        myAlert.show(`conversion  from ${update.traffic} on ${update.sub_id}=>$${update.payout}`, {type:"success",
  //       })
  // }, []);

  useEffect(() => {
    let isMounted = true; // Add a flag to track component mount status

    if (socket && user.status === "superadmin") {
      const handleConversionUpdate = (update) => {
        if (!isMounted) return; // Check if component is still mounted

        console.log({
          update,
          conversion_update: true,
          audioshow,
        });

        // Play the sound
        if (audioshow) {
          console.log("going to play audio now");
          const audio = new Audio(bubbleSound);
          audio.play();

          // return;

          // if (window._currentAudio) {
          //   window._currentAudio.pause();
          //   window._currentAudio.src = "";
          //   window._currentAudio = null;
          // }

          // const myaudio = new Audio(update.audiofile);
          // myaudio.volume = 1.0;        // 0.0–1.0
          // myaudio.playbackRate = 1.0;  // optional
          // window._currentAudio = myaudio;

          // try {
          //    myaudio.play();      // succeeds because we're in a click handler
          // } catch (e) {
          //   console.warn("Playback blocked:", e);   // user gesture required
          // }

          //   myaudio.onended = () => {
          //   URL.revokeObjectURL(update.audiofile); // clean up
          //   window._currentAudio = null;
          // };
        }

        myAlert.show(
          `${update.traffic} paid $${parseFloat(update.payout).toFixed(2)}`,
          {
            type: "success",
            containerStyle: {
              width: "500px", // Adjust the width as needed
            },
          },
        );
        // triggerAlert(update.sub_id, update.traffic, update.payout)
        fetchConversions();
      };

      socket.on("conversion_update", handleConversionUpdate);

      // Cleanup function to remove the listener when the component unmounts or the dependencies change
      return () => {
        isMounted = false; // Set flag to false when component unmounts
        socket.off("conversion_update", handleConversionUpdate);
      };
    }
  }, [socket, audioshow]);

  const fetchpaydata = async (id) => {
    try {
      let data = await REQ(
        "GET",
        `${GLOBAL.domainDataowner}/api/payment-summary-affilliate/${id}`,
        null,
        true,
      );

      data = data.data;

      console.log(data);
      setbalancechart(data?.totalowed);
    } catch (error) {
      // alert(error?.response?.data?.message || "an error occured");
      console.log(error);
    }
    // setloading(false);
  };

  const fetchNumberChangerBalance = async () => {
    try {
      let data = await REQ(
        "GET",
        `${GLOBAL.domain}/api/numberchangerpayments/balance`,
        null,
        true,
      );

      data = data.data;

      console.log(data);
      setbalancechart(data?.balance);
    } catch (error) {
      console.log(error);
      // alert(error?.response?.data?.message || "an error occured");
    }
    // setloading(false);
  };

  const fetchConversions = async (status) => {
    // fetchConversions
    console.log("awesome!!");
    try {
      setrevloading(true);

      let url = `${GLOBAL.domainClickGet}/api/conversions-all?limit=8&isdetailed=no&fixedRangeValue=0`;
      let { data } = await REQ("GET", url, null, true);
      // const {data} = await Axios.get( , {

      // })

      setrevtoday(data.totalPayout);

      console.log({ dailyConversion: data });
    } catch (error) {
      console.log(error);
    } finally {
      setrevloading(false);
    }
    //
  };

  return (
    <>
      <Sidebar
        status={status}
        showingsidebar={sidebar}
        setSideBar={showSideBar}
      />
      <div className={classes.Layout}>
        {status == "superadmin" && (
          <div className={classes.RevDiv}>
            <p className={classes.RevToday} style={{ marginRight: 10 }}>
              <FontAwesomeIcon icon={faCalendarDay} />:{" "}
              {revloading ? (
                <img src={tk} height={15} style={{ marginRight: 10 }} />
              ) : (
                <span>{formatter.format(`${revtoday}`)} </span>
              )}
              <FontAwesomeIcon
                style={{ marginRight: 10 }}
                icon={faRedo}
                onClick={() => {
                  fetchConversions();
                }}
              />
              <FontAwesomeIcon
                style={{
                  marginRight: 10,
                }}
                icon={faBullhorn}
                onClick={() => {
                  // window.location.href = "/conversion-per-hour"

                  setaudioshow((prevState) => !prevState);
                }}
              />
              {!audioshow && (
                <FontAwesomeIcon
                  onClick={() => {
                    setaudioshow((prevState) => !prevState);
                  }}
                  style={{
                    position: "absolute",
                    marginLeft: -27, // Adjust as needed
                    fontSize: "16px", // Adjust as needed
                    color: "white", // Adjust as needed
                  }}
                  icon={faSlash}
                />
              )}
              <FontAwesomeIcon
                icon={faArrowCircleRight}
                onClick={() => {
                  window.location.href = "/super/allrev";
                }}
              />
            </p>
          </div>
        )}
        {/* <LinearProgress value={100} variant="determinate" /> */}
        <div className={classes.Header}>
          <p className={classes.logo}>
            <a
              style={{
                textDecoration: "none",
                color: "black",
              }}
              href="/"
            >
              <img src={Logosvg} />
            </a>
          </p>
          <div
            className={classes.SnackBar}
            onClick={() => showSideBar(!sidebar)}
          >
            <div></div>
            <div></div>
            <div></div>
          </div>
          {status == "superadmin" ? (
            <ul className={classes.DesktopOnly}>
              <div className={classes.MessagingAppsCont}>
                <li onClick={() => setShow(!showingMessageDropdown)}>
                  Messaging Apps
                </li>
                <div className={classes.MessagingApps}>
                  <div>
                    <a href="/sms/64-port-verizon">
                      <div className={classes.fullWidth}>
                        In-House SMS with 64 PORT Machines
                      </div>
                    </a>
                    <a href="/sms/iq">
                      <div className={classes.fullWidth}>
                        In-House SMS with IQ SIM MACHINES
                      </div>
                    </a>
                    <a href="/sms/512">
                      <div className={classes.fullWidth}>
                        In-House SMS with 512 SIM MACHINES
                      </div>
                    </a>
                  </div>
                  <div>
                    <a href="/sms/tmobilesender">
                      <div className={classes.fullWidth}>
                        In-House SMS with Tmobile
                      </div>
                    </a>
                  </div>
                  <div>
                    <a href="/smsbeta/tmo">
                      <div className={classes.fullWidth}>API TMO SENDER</div>
                    </a>
                  </div>
                  <div>
                    <a href="/smsbeta/512">
                      <div className={classes.fullWidth}>API 512 SENDER</div>
                    </a>
                  </div>
                </div>
              </div>

              <li>
                <a href="/namecheap">Bulk Forward</a>
              </li>

              <li>
                <a href="/click-tracker">Clicks</a>
              </li>
              <li>
                <a href="/domain-checker">Domain Checker</a>
              </li>
              <li>
                <a href="/conversion-tracker">Conversions</a>
              </li>
              <li>
                <a href="/message-formatter">Formatter</a>
              </li>
              <li>
                <a href="/message-formatter-api-leads">Formatter V2</a>
              </li>
              <li>
                <a href="/message-previewer">Message Preview</a>
              </li>
              <li>
                <a href="/v2/scrub">Scrub File</a>
              </li>
              <li>
                <a href="/datagroups">Data Groups</a>
              </li>

              <li>
                <a href="/allsubs">All Subs</a>
              </li>
              <li>
                <a href="/subid-create">Create Sub</a>
              </li>
              {/* <li>
                <a href="/profit-sharers">Profit Sharers</a>
              </li> */}
              <li>
                <a
                  onClick={() => localStorage.removeItem("token")}
                  href="/auth"
                >
                  Logout
                </a>
              </li>

              <li>
                <RealtimeClock />
              </li>
            </ul>
          ) : status === "visitor" ? (
            <ul>
              <li>
                <a href="/conversion-tracker">Conversion Tracker</a>
              </li>
              <li>
                <a
                  onClick={() => localStorage.removeItem("token")}
                  href="/auth"
                >
                  Logout
                </a>
              </li>
            </ul>
          ) : (
            <ul>
              <li>
                <a
                  onClick={() => localStorage.removeItem("token")}
                  href="/auth"
                >
                  Logout
                </a>
              </li>
            </ul>
          )}
        </div>

        <div className={classes.ChildrenPanel}>
          {/* <button 
          onClick={() => {
            const audio = new Audio(bubbleSound);
            audio.play();
          }} className={classes.PlayButton} style={{display: showAlert ? "none" : "block"}}>Play</button> */}
          <Offline>
            {" "}
            <p className={classes.OfflineStyle}>
              {" "}
              You are not currently connected to the Internet. Some services may
              not function properly
            </p>
          </Offline>
          {children}
        </div>
      </div>
    </>
  );
}

export default withRouter(Layout);
